module.exports = __webpack_public_path__ + "img/class3.df51fc57.png";